// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 持久化状态枚举 枚举类
 * 持久化状态枚举，用于确定持久化操作，本字段并不持久化
 */
export enum EnumPersistenceStatus {
  /** 无修改 : 无修改 */
  None = 0,
  /** 新建的 : 新建的 */
  Create = 1,
  /** 已修改的 : 已修改的 */
  Update = 2,
  /** 逻辑删除 : 已逻辑删除的 */
  Delete = 4,
  /** 物理删除 : 已物理删除的 */
  Remove = 8
}

/**
 * 持久化状态枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumPersistenceStatusMD {
  private static items = [
    new EnumItemMD('None', 0, '无修改', '无修改'),
    new EnumItemMD('Create', 1, '新建的', '新建的'),
    new EnumItemMD('Update', 2, '已修改的', '已修改的'),
    new EnumItemMD('Delete', 4, '逻辑删除', '已逻辑删除的'),
    new EnumItemMD('Remove', 8, '物理删除', '已物理删除的')
  ];

  static getItem(enumItem: EnumPersistenceStatus) {
    return this.items.find(item => item.name === EnumPersistenceStatus[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
